const cn = {
  message: {
    Save_cmd: '存档',
    Cancel_cmd: '取消',
    Close_cmd: '关闭窗口',
    Edit_cmd: '编辑',
    Del_cmd: '删除',
    Query_cmd: '查询',
    Send_cmd: '确认送出',
    Sign_in: '登入',
    Confirm_txt: '确定',
    Confirm_txt: '载入中',
    Error_txt: '错误',
    Success_txt: '成功',
    Warning_txt: '警告',
    Info_txt: '消息',
    Upload_txt: '点击上传',
    Back_txt: '上一步',
    Next_txt: '下一步',
    Keep_txt: '资料暂存',
    Check_txt: '资料检查',
    Contact_txt: '连络我们',
    Home_txt: '回勤益首页',
    Preview_txt: '上一页',
    NextPage_txt: '下一页'
  }
}
export default cn


// WEBPACK FOOTER //
// ./src/i18n/lang/zh_CN.js